import React from "react";
import "./app.css";
import Routes from "./Routes";

function App(props) {
	return <Routes childProps={{ ...props }} />;
}

export default App;
